export const FEATURE_BADGES = {
  workspaceManagement: { releaseAt: '2026-08-28T00:00:00.000Z' },
  secrets: { releaseAt: '2026-08-28T00:00:00.000Z' },
  sharedSecrets: { releaseAt: '2026-10-13T00:00:00.000Z' },
  mailbox: { releaseAt: '2026-08-28T00:00:00.000Z' },
  contacts: { releaseAt: '2026-08-28T00:00:00.000Z' },
  roadmap: { releaseAt: '2026-08-28T00:00:00.000Z' },
  releaseNotes: { releaseAt: '2026-08-28T00:00:00.000Z' },
  usageLimits: { releaseAt: '2026-09-21T00:00:00.000Z' },
  workspaceConfigurations: { releaseAt: '2026-10-29T00:00:00.000Z' },
} as const;

export type FeatureBadgeId = keyof typeof FEATURE_BADGES;

function toTimestampMs(value?: string | number | null): number | null {
  if (value == null || value === '') return null;
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }
  const trimmed = value.trim();
  if (/^\d+$/.test(trimmed)) {
    const numeric = Number(trimmed);
    return Number.isFinite(numeric) ? numeric : null;
  }
  const parsed = Date.parse(trimmed);
  return Number.isFinite(parsed) ? parsed : null;
}

/**
 * A New badge only introduces a feature to people whose account predates it.
 * If the account creation date is unavailable, fail closed so new accounts do
 * not receive a misleading badge while their profile is loading.
 */
export function isNewFeatureForUser(featureId: FeatureBadgeId, accountCreatedAt?: string | number | null): boolean {
  const accountCreatedAtMs = toTimestampMs(accountCreatedAt);
  if (accountCreatedAtMs == null) return false;
  const releaseAtMs = Date.parse(FEATURE_BADGES[featureId].releaseAt);
  return Number.isFinite(releaseAtMs) && accountCreatedAtMs < releaseAtMs;
}
